import { Collapse, CollapseProps } from '@mui/material'
import React from 'react'

export type WcCollapseProps = CollapseProps ;

export const WcCollapse = ({children,...props}: WcCollapseProps) => (
    <Collapse {...props}>{children}</Collapse>
  )